import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {getData} from '../../Actions/DropDown/getData';
import {getReferral} from '../../Actions/DropDown/getReferral';
import {getReferrals} from '../../Actions/DropDown/getReferrals';

class Radio extends React.PureComponent {
    state = {
        visible: true,
        selected: '',
    };

    componentWillMount() {
        this.props.getData({key: this.props.dataKey});
        this.update = this.update.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.options && props.options.length === 1) {
            this.props.onChange(props.options[0][(props.editable ? 'id' : 'key')]);
            this.setState({visible: false});
            return;
        }
        this.setState({visible: true});
    }

    update(e) {
        this.props.onChange(e.target.value);
    }


    render() {
        return (
            <div className="input-radio-group">
                {this.props.options.length === 0 ? <option value="">Loading...</option> : null}
                {this.props.options.map(o => (
                    <div className={['input-radio', this.props.classes && this.props.classes].join(' ')}
                         key={o.id + this.props.name}>
                        <input
                            type="radio"
                            id={this.props.name + (this.props.editable ? o.value : o.key)}
                            value={this.props.editable ? o.id : o.key}
                            onChange={this.update}
                            name={this.props.name}
                            checked={(this.props.name === "assessment[smoking_type_id]" || this.props.name === "smokingtype") ? (this.props.value === (o.id).toString()) : (this.props.value === (this.props.editable ? o.value : o.key))}
                            key={this.props.name + o.id}
                        />
                        <label key={o.id + this.props.name + o.id}
                               htmlFor={this.props.name + (this.props.editable ? o.value : o.key)}>{o.value}</label>
                    </div>

                ))}
            </div>
        );
    }
}

Radio.propTypes = {
    dataKey: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    editable: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    getData: PropTypes.func.isRequired,
    getReferrals: PropTypes.func.isRequired,
    getReferral: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    const data = {
        ...ownProps,
        options: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].options : [],
        editable: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].editable : 0,
    };

    if (ownProps.dataKey === 'referrals' && ownProps.level === 2 && state.dropdowns.referrallevel2) {
        data.options = state.dropdowns.referrallevel2.options ? state.dropdowns.referrallevel2.options : [];
    }

    if (ownProps.dataKey === 'referrals' && ownProps.level === 3 && state.dropdowns.referrallevel3) {
        data.options = state.dropdowns.referrallevel3.options ? state.dropdowns.referrallevel3.options : [];
    }

    data.options.sort((a, b) => (a.value > b.value ? 1 : -1));

    const sortBy1 = [2004, 2003, 2001, 2000, 2002];
    data.options.sort((a, b) => sortBy1.indexOf(a.id) - sortBy1.indexOf(b.id));

    const sortBy2 = [2008, 2006, 2007, 2009, 2005];
    data.options.sort((a, b) => sortBy2.indexOf(a.id) - sortBy2.indexOf(b.id));

    return data;
};

const mapDispatchToProps = (dispatch, ownProps) => (
    {
        getData: (p) => {
            dispatch(getData(p));
        },
        getReferrals: () => {
            dispatch(getReferrals());
        },
        getReferral: (id) => {
            dispatch(getReferral(id));
        },
    }
);

const RadioLink = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Radio);

export default RadioLink;



// WEBPACK FOOTER //
// ./src/Components/Inputs/Radio.jsx